// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/api.js";
import ___CSS_LOADER_GET_URL_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/getUrl.js";
var ___CSS_LOADER_URL_IMPORT_0___ = new URL("../../../../ASSETS/BACKGROUND/HomePageBG_2x-100.jpg", import.meta.url);
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
var ___CSS_LOADER_URL_REPLACEMENT_0___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_0___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.hero-section {
  background-color: black; /* or any color that matches your design */
  min-height: 80vh; /* Ensures the section always has a minimum height */
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_0___});
  background-size: cover;
  background-position: center;
  color: white;
  display: flex;
  align-items: center;
  justify-content: center;
}
.hero_text_block {
  max-width: 850px;          /* ✅ Controls width — fixes alignment */
  text-align: center;        /* ✅ Ensures centered text */
  line-height: 1.6;          /* ✅ Perfect readable spacing */
  padding: 20px;
  
}

.hero_text_block p {
  font-size: 1.5rem;
  margin-bottom: 1.5rem;     /* ✅ Equal spacing between paragraphs */
  color: #e9f1f3;      
        /* ✅ Soft white, not harsh */
}
.text-container {
  text-align: center !important;
  padding: 20px;
  background-color: rgba(0, 0, 0, 0);
  border-radius: 8px;
}
.text-container1 {
 display: flex;
  justify-content: center;
}
.highlight {
  color: #FFE600;
}

.hero_title {
  font-size: 5rem;
}

.hero_subtitle {
  font-size: 1.5rem;
}
`, "",{"version":3,"sources":["webpack://./src/PAGES/HOME/SECTIONS/HERO/index.css"],"names":[],"mappings":"AAAA;EACE,uBAAuB,EAAE,0CAA0C;EACnE,gBAAgB,EAAE,oDAAoD;EACtE,yDAA4E;EAC5E,sBAAsB;EACtB,2BAA2B;EAC3B,YAAY;EACZ,aAAa;EACb,mBAAmB;EACnB,uBAAuB;AACzB;AACA;EACE,gBAAgB,WAAW,uCAAuC;EAClE,kBAAkB,SAAS,4BAA4B;EACvD,gBAAgB,WAAW,+BAA+B;EAC1D,aAAa;;AAEf;;AAEA;EACE,iBAAiB;EACjB,qBAAqB,MAAM,uCAAuC;EAClE,cAAc;QACR,4BAA4B;AACpC;AACA;EACE,6BAA6B;EAC7B,aAAa;EACb,kCAAkC;EAClC,kBAAkB;AACpB;AACA;CACC,aAAa;EACZ,uBAAuB;AACzB;AACA;EACE,cAAc;AAChB;;AAEA;EACE,eAAe;AACjB;;AAEA;EACE,iBAAiB;AACnB","sourcesContent":[".hero-section {\n  background-color: black; /* or any color that matches your design */\n  min-height: 80vh; /* Ensures the section always has a minimum height */\n  background-image: url(\"../../../../ASSETS/BACKGROUND/HomePageBG_2x-100.jpg\");\n  background-size: cover;\n  background-position: center;\n  color: white;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n}\n.hero_text_block {\n  max-width: 850px;          /* ✅ Controls width — fixes alignment */\n  text-align: center;        /* ✅ Ensures centered text */\n  line-height: 1.6;          /* ✅ Perfect readable spacing */\n  padding: 20px;\n  \n}\n\n.hero_text_block p {\n  font-size: 1.5rem;\n  margin-bottom: 1.5rem;     /* ✅ Equal spacing between paragraphs */\n  color: #e9f1f3;      \n        /* ✅ Soft white, not harsh */\n}\n.text-container {\n  text-align: center !important;\n  padding: 20px;\n  background-color: rgba(0, 0, 0, 0);\n  border-radius: 8px;\n}\n.text-container1 {\n display: flex;\n  justify-content: center;\n}\n.highlight {\n  color: #FFE600;\n}\n\n.hero_title {\n  font-size: 5rem;\n}\n\n.hero_subtitle {\n  font-size: 1.5rem;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
